import React from "react";
import "../assete/css/paperwriting.css";
import Header from "./Header";
import paper_pic_1 from "../assete/research service/reser1-min.jpg";
import paper_pic_2 from "../assete/research service/research_paper1-min (1).jpg";
import paper_pic_3 from "../assete/research service/research 1-min.png";
import papaer_write_vdo from "../assete/bannerimage/360_F_1053556729_ScK4ULAxzwEbvzzJODAwsxR63ARwLuYm.jpg";
import Footer from "./Footer";
const ResearchPaperservice = () =>{

    return(
        <>
        <Header/>
         <div className='paper_write_div'>
        
           <img src={papaer_write_vdo} alt=""/>
        
                <div className="about_content">
            <h1>Research Paper Writing </h1>
            </div>
        
           </div>
           <div className='new_design_padding'>
           <div className='paper_main_write_div'>
           <div className='paper_write_main_div'>
                <div className='paper_write_conts' >
                    <h2>Research Paper Writing Service in kanyakumari</h2>
                    <p>Research paper writing, being the decisive factor for a career, becomes inevitable to get help from someone who has thorough knowledge in the field of research. Research paper writing services at Sea Sense are handled and written by the institutional parameters involving the style, design and format of an ideal dissertation. We assist you in all the stages, including dissertation topic selection, research proposal and the dissertation content development.</p>
                    <h2>What We Do?</h2>
                    <p> Our experts commit themselves to exploring their foremost services towards the demand of scholars. At the same time, our experts are aware of all the hazards of research paper writing which will afford better solutions. Experts do astonishing things as easily as our writers do. The professional writers in our company can handle any type of project. Whatever the subject maybe, their quality is always on the top.</p>
                </div>
                <div className='paper_write_div_pic'>
                    <img src={paper_pic_1} alt=""  />
                </div>
           </div>
        <div className='paper_sub'>
           <div className='paper_sub_div'>
            <div className='paper_sub_div_pic'>
                <img src={paper_pic_2} alt="" />
            </div>
            <div className='paper_div_conts' >
                <h2>We offer the following guarantees in our service for writing research papers:</h2>
                <p>Context-related literature research with a conceptual framework.</p>
                <p>Use of current references.</p>
                <p>Grammar-free with proofreading.</p>
                <p>Scientific / technical writing style.</p>
            <p>Thought provoking coherence of paper.</p>
                <p>Fast processing time.</p>
            </div>
           </div>
           </div>
        
           <div className='paperwrite_sub_cont_div'>
            <div className='paperwrite_sub_cont_div_1' >
                <h2>Data collection:</h2>
                <p>Identifying the topic you want to write about should be the primary concern while experts from research paper writing services deal with it. A deep look into the internet, journals, books or articles will help you take a look at previous studies to gather all the relevant data, graphs, charts, tables, analyses, etc. that will prove to be helpful.</p>
                <h2>Findings:</h2>
                <p>You need to identify two or more important findings from the data you have collected and use them as a central theme in creating the first draft of a research paper. However, our experts in research writing   follow different writing styles to help you get your desired results.</p>
                <h2>Research Paper Structure</h2>
                <p>There is an adequate research writing structure in place followed by our research writing service in Sea Sense which will assist you in producing high quality reports. It's listed below:</p>
               
              
            </div>
            <div className='paperwrite_sub_cont_div_pic'>
                <img src={paper_pic_3} alt="" />
            </div>
           </div>
           <div className='paper_div_sub_card'>
          <p><label>Title</label><span>Write a title that is short, simple and attractive. It gives the reader a brief idea of ​​the research you will write in your report.</span></p>
          <p><label>Abstract</label><span>A small summary is presented briefly and effectively. You need to incorporate key insights in a way that readers can see and understand.</span></p>
          <p><label>Graphics</label><span>Our research paper writing service in Sea Sense will show you the importance of including an illustration or diagram to educate readers about the subject.</span></p>
          <p><label>Introduction</label><span>You need to be there while you write your introduction. You need to start a specific section by keeping a specific background on the topic in mind.</span></p>
          <p><label>Experimental Section</label><span>Our experts helping with research writing tend to divide the mentioned section into methods, measurements, data analysis and characterizations.</span></p>
        </div>
        
           </div>
           </div>
        <Footer/>
        </>
    )
}

export default ResearchPaperservice